<template lang="pug">
section.p-top
  section.container
    .text-center
      .d-flex.justify-content-center.align-items-center.cart-bg
        vue-typed-js(:strings="['通过账号和邮箱信息来重置密码哟~']", :fadeOut="true")
          h3.text-white.typing.cart-text
    .my-5.row.justify-content-center(v-show="form.result.code != 200")
      form.col-md-6(@submit.prevent="submit()", ref="form")
        .form-group
          label(for="userid") 用户名
          input#userid.form-control(
            type="text",
            name="userid",
            v-validate="{ min:6, max:14, required:true, alpha_num:true }",
            :class="{ 'is-invalid': errors.has('userid') }",
            v-model="form.user.userid",
            placeholder="请输入用户名"
          )
          span.text-danger(v-if="errors.has('userid')") 用户名长度为6-14位（字母和数字）
        .form-group
          label(for="user_pass") 密码
          input#user_pass.form-control(
            type="password",
            name="user_pass",
            :class="{ 'is-invalid': errors.has('user_pass') }",
            v-model="form.user.user_pass",
            v-validate="{ min:6, max:14, required:true, alpha_num:true }",
            placeholder="请输入密码"
          )
          span.text-danger(v-if="errors.has('user_pass')") 密码长度为6-14位（字母和数字）
        .form-group
          label(for="email") 邮箱Email
          input#email.form-control(
            type="text",
            name="email",
            v-validate="'required|email'",
            :class="{ 'is-invalid': errors.has('email') }",
            v-model="form.user.email",
            placeholder="请输入邮箱"
          )
          span.text-danger(v-if="errors.has('email')") 邮箱格式不正确
        .form-group
          label(for="new_user_pass") 重置新密码
          input#new_user_pass.form-control(
            type="password",
            name="new_user_pass",
            :class="{ 'is-invalid': errors.has('new_user_pass') }",
            v-model="form.user.new_user_pass",
            v-validate="{ min:6, max:14, required:true, alpha_num:true }",
            placeholder="请输入新密码"
          )
          span.text-danger(v-if="errors.has('new_user_pass')") 密码长度为6-14位（字母和数字）
        .form-group
          label(for="new_user_pass2") 确认新密码
          input#new_user_pass2.form-control(
            type="password",
            name="new_user_pass2",
            :class="{ 'is-invalid': errors.has('new_user_pass2') }",
            v-model="form.user.new_user_pass2",
            v-validate="{ min:6, max:14, required:true, confirmed: form.user.new_user_pass }",
            placeholder="请再次输入新密码"
          )
          span.text-danger(v-if="errors.has('new_user_pass2')") 请确认两次密码一致
        .text-right
          //- span.text-danger(style="margin-right:20px;") 功能暂未开放，敬请期待！~
          span.text-danger(
            style="margin-right:20px;",
            v-if="form.result.code != 0 && form.result.code != 200"
          ) {{ form.result.message || '密码重置失败，请联系客服处理。QQ号: 1941160499' }}
          button.btn.btn-danger 
            | 确定重置
    .my-5.row.justify-content-center(v-if="form.result.code == 200")
      .col-md-6.text-center
        img(src="http://res.99ro.top/web-assets/img/logo.png", alt="", srcset="")
        br 
        br
        span.text-info 密码重置成功~ 祝您游戏愉快！
</template>

<script>
import * as accountAPI from '@/api/account';

/* global $ */
export default {
  data() {
    return {
      isLoading: false,
      form: {
        user: {
          userid: '',
          user_pass: '',
          new_user_pass: '',
          new_user_pass2: '',
          email: ''
        },
        result: {
          code: 0,
          message: ''
        }
      }
    };
  },
  methods: {
    submit() {
      const vm = this;
      vm.$validator.validate().then((validateResult) => {
        if (!validateResult) return;
        if (this.isLoading) return;
        this.isLoading = true;
        accountAPI.updatePassword(vm.form.user).then((res) => {
          vm.form.result.code = res.data.code;
          vm.form.result.message = res.data.message;
        }).catch((err) => {
          vm.form.result.code = err.response.data.code;
          vm.form.result.message = err.response.data.message;
          console.log(err);
        }).finally(() => {
          this.isLoading = false;
        });
      })
    },
  },
  created() {
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.p-top {
  padding-top: 91px;
}
.cart-bg {
  background-image: url(http://res.99ro.top/web-assets/img/background3.jpg);
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 375px;
}
.cart-text {
  background-color: rgba(0, 0, 0, 0.6);
  padding: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/ResetPassword.vue